// src/components/sections/Shop.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import { loadStripe } from '@stripe/stripe-js';

// Debug log
console.log('Checking Stripe key:', {
  hasKey: !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  keyLength: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.length
});

const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY 
  ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  : null;

const Shop = () => {
  const [loading, setLoading] = useState(false);

  const handlePreOrder = async () => {
    try {
      setLoading(true);
      console.log('Starting checkout process...');
      
      // Verify Stripe initialization
      if (!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
        throw new Error('Stripe publishable key is missing in environment variables');
      }
      
      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe failed to initialize. Missing publishable key.');
      }

      console.log('Stripe initialized successfully');

      // Make request to our API route
      const response = await fetch('/api/checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error?.message || 'Failed to create checkout session');
      }

      // Redirect to Stripe checkout
      const result = await stripe.redirectToCheckout({
        sessionId: data.id
      });

      if (result.error) {
        throw new Error(result.error.message);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      alert('Checkout error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <section className="min-h-screen py-8 px-4">
      <motion.div 
        initial="initial"
        animate="animate"
        className="max-w-3xl mx-auto text-center"
      >
        <h2 className="text-4xl font-['Orbitron'] mb-16 inline-block">
          <span className="bg-gradient-to-r from-[#805AD5] to-[#FF4D00] bg-clip-text text-transparent border-b-2 border-[#805AD5] pb-2">
            Presenting
          </span>
        </h2>

        <motion.div 
          variants={fadeIn}
          className="space-y-8"
        >
          {/* Album Cover Image - Optimized sizing */}
          <div className="relative w-full max-w-md mx-auto aspect-square mb-12">
            <img 
              src="/LiveatthecomplexSF.png"
              alt="Live at the Complex SF - Album Cover"
              className="w-full h-full object-cover rounded-lg shadow-2xl"
            />
          </div>

          {/* Album Details */}
          <div className="space-y-4">
            <h3 className="text-2xl font-['Orbitron'] text-white">
              Live... At the Complex SF
            </h3>
            <p className="text-gray-300">
              Performed Live by Sonny.SOUF and Belafonte97
            </p>
            <div className="text-3xl text-white font-bold my-8">
              $9.99
            </div>
          </div>

          {/* Pre-Order Button */}
          <button
            onClick={handlePreOrder}
            className="bg-gradient-to-r from-[#805AD5] to-[#FF4D00] text-white 
                     px-12 py-4 rounded-lg font-['Orbitron'] text-lg
                     hover:opacity-90 transition-all transform hover:-translate-y-1"
          >
            Pre-Order Now
          </button>

          {/* Delivery Note */}
          <p className="text-gray-400 text-sm mt-4">
            * Digital delivery upon release
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Shop;